import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import app from "./modules/app.js";
import {fetchNewColumnPage} from "../api/column";

Vue.use(Vuex);

export function createStore() {
  return new Vuex.Store({
    state: {
      envConfig: process.env.config,
      archiveDetail: null, //--文章详情
      productionDetail: null, //--作品详情
      worksList: null,
      activityInfoDetail: null, //作品活动征集详情页面
      userDetail: null, //--个人详情
      topicsList: null,
      topicsListTotal:null,
      topicDetail: null,
      // weiboToken:null,
      liveDetail:null, //--直播详情
      videoDetail:null, //--点播详情
      modelDetail:null,
      worksMeta:null, //作品列表页
      columnMeta:null,
      columnTypeMeta:null,
      questionDetail:null, //问题详情
      sectionDetail:null,
      davartList:null,
      columnList:null,
      //staticKeyWords:" 类型：影视动漫,剪辑合成,分镜设计,广告企业宣传,游戏,美术设计,脚本,模型制作,动画制作,特效制作,音效配音,短视频,动新闻,其它,场景,插画,人物,概念,素描,生物,道具,动作捕捉,K帧",

      /***
       * 新版
       */
      newProductionPage:null,
      newUserDetail:null,
      rankUserList:null,

      newIndexProductionList:null, //新版首页 -动画短片
      newIndexStoryList:null,//新版首页 -传统文化
      newIndexCourseList:null,//新版首页 -动画制作

      newIndexVideoProductionOneList:null, //动画短片--经典获奖
      newIndexVideoProductionTwoList:null, //动画短片--国内优秀
      newIndexVideoProductionThreeList:null, //动画短片--传统文化

      //传统文化板块，使用首页传统文化 对象

      newIndexMakeProductionList:null, //动画制作-作品
      newIndexMakeModelList:null,     //动画制作-素材

      indexRightChoList:null,

      newArchivePage:null,
      newQuestionPage:null,
      newModelPage:null,

      //newProductionDetail:null,
    },
    modules: {
      app
    },
    mutations,
    actions,
    getters
  });
}
